export default function fetch(url, ...args) {
    return new Promise((accept, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.addEventListener("load", function() {
            let {responseText, status, statusText, responseURL=url} = xhr;

            if (status !== 200) {
                reject(new Error(`File '${url}' ${statusText}`));
                return;
            }

            try {
                let response = JSON.parse(responseText);
                accept({response, responseURL, xhr});
            } catch (err) {
                reject(new Error(`Error: ${err.message} while parsing '${url}'`));
            }
        }, false);

        xhr.open("GET", url, true);
        xhr.send();
    });
}



// WEBPACK FOOTER //
// ./src/kpi/lib/fetch.js